module.exports = __webpack_public_path__ + "img/hic-cerebrovascular-disease-female.d5f3b33a.png";